import React from 'react';

export default function LoadingScreen({ error, onRetry }) {
  if (error) {
    return (
      <div className="loading-screen">
        <p>🌧️ {error}</p>
        {onRetry && <button className="btn" onClick={onRetry}>Retry</button>}
      </div>
    );
  }

  return (
    <div className="loading-screen">
      <div className="loading-spinner" />
      <p>Loading Grove…</p>
    </div>
  );
}
